export default {
    GA_TRACKING_ID: 'G-YSD2Q29TGC', //ga的id
    GA_AW_ID: 'AW-408174131', //ga的id
    event(eventCategory, eventAction, eventLabel, eventValue) {
        if (window.gtag) {
            window.gtag('event', eventAction, {
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue,
                send_to: this.GA_TRACKING_ID,
                'debug_mode':true,
            })
        }
    },
    page(page) {
        if (window.gtag) {
            window.gtag('config', this.GA_TRACKING_ID, {
                page_path: page,
            })
        }
    },
    twPage() {
        if (window.gtag) {
            window.gtag('event', 'conversion', {
                send_to: 'AW-408174131/fSkLCP6Dr60DELP80MIB',
                'debug_mode':true,
            })
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/radio_ga.js
// module id = QToU
// module chunks = 20